// extracted by mini-css-extract-plugin
export var logo = "_j0-2";
export var logoWrapper = "_j0-1";
export var strip = "_j0-0";